import * as React from "react";
import ReactQuill from "react-quill";
import DOMPurify from "dompurify";
import "react-quill/dist/quill.snow.css";
import { store } from "../../redux/store";
import { connect } from "react-redux";
import { match } from "react-router-dom"; //needed for 'location' object and 'match.params'
import { mapDispatchToProps, updateReduxAction } from "../../redux/actions";
import "../../css/FactoryRequests.scss";
import { IOption } from "./MultiSelectDropDown";
import MultiSelectDropDown from "./MultiSelectDropDown";
interface IProps {
  updateRedux: any;
  reduxFactoryModifications:any;
  reduxFactoryRequestUnits:any;
  reduxFactoryRequest:any;
  disableUI:boolean;
  modificationsInvalid:boolean;
}
interface IState {
}
class Modifications extends React.Component<IProps, IState> {
  quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "indent",
    "align"
  ];
  private quillRefs: { [key: number]: ReactQuill | null } = {};

  private getModifications() {
    return this.props.reduxFactoryModifications.modifications;
  }
  /* Add Modification */
  private addModification(){
    const newModifications = [
      ...this.getModifications(),
      {
        id: Date.now(),
        ModificationType: "Select Type",
        ModifiedUnits: "",//Give all new modifications an initial value of "All" Units.
        Description: ""
      }
    ];

    this.props.updateRedux("UPDATE_MODIFICATIONS", {modifications: newModifications});
  };
  /* Remove Modification */
  private removeModification(id: number) {
    const newLines = this.getModifications().filter((l:any) => l.id !== id);
    this.props.updateRedux("UPDATE_MODIFICATIONS", {modifications: newLines});
  };
  //Special updating when ModificationType changes.
  private updateModificationType(id: number, value: string){
    const newLines = this.getModifications().map((line:any) =>
      line.id === id ? { ...line, "ModificationType": value, "Description": "" } : line
    );
    this.props.updateRedux("UPDATE_MODIFICATIONS", {modifications: newLines});
  }
  //Don't allow dangerous tags in our rich text editor.
  private sanitizeAndSaveRichText(id: number,field: string, value: string){
    const cleanHtml = DOMPurify.sanitize(value, {
      ALLOWED_TAGS: [
        "p", "br",
        "strong", "em", "u",
        "h1", "h2", "h3",
        "ul", "ol", "li"
      ],
      ALLOWED_ATTR: ["class"], // needed for alignment classes
      FORBID_TAGS: [
        "style",
        "script",
        "iframe",
        "object",
        "embed",
        "img",
        "video"
      ],
      FORBID_ATTR: [
        "style",
        "onclick",
        "onerror",
        "onload"
      ],
      ALLOW_DATA_ATTR: false
    });
    this.updateField(id, field, cleanHtml);
  }
  private getAvailableUnitOptions(requestType:string){
    if(requestType === "Submittal"){
      return this.getUnitOptions(true);
    }
    else {
      return this.getUnitOptions(false);
    }
  }
  private checkIfSubmittalUnitsIncludeAll(requestType:string){
    if (requestType !== "Submittal"){
      return true;
    }
    else {
      if (this.props.reduxFactoryRequest.factoryRequest.SelectedUnits?.includes("All")){
        return true;
      }
      else {
        return false;
      }
    }
  }
  /* Update Field */
  private updateField(id: number,field: string, value: string) {
    if (field === "Description" && this.getPlainTextLength(value) > 4000) return;

    const newLines = this.getModifications().map((line:any) =>
      line.id === id ? { ...line, [field]: value } : line
    );
    this.props.updateRedux("UPDATE_MODIFICATIONS", {modifications: newLines});
  };
  getPlainTextLength = (html: any) => {
    if (!html) return 0;
  
    const div = document.createElement("div");
    div.innerHTML = html;
  
    return (div.innerText || "").replace(/\n$/, "").length;
  };
  public render() {
    const requestType = this.props.reduxFactoryRequest.factoryRequest?.RequestType;
    const submittalUnitChoiceIncludesAll = this.checkIfSubmittalUnitsIncludeAll(requestType);//Pass this to Multiselect to determine to show "All"
    const unitOptions = this.getAvailableUnitOptions(requestType);
    const elementClass = this.props.disableUI ? "element-disable" : "";
    return (
      <div className="custom-lines-container">

        {/* Header */}
        <div className="custom-lines-header">
          <div>Unit Modifications</div>
          <div>Unit(s)</div>
          <div>Description</div>
          <div></div>
        </div>

        {/* Rows */}
        {this.getModifications().map((line:any) => {
          const modules = {toolbar: `#toolbar-${line.id}`};
          return (
            <div key={line.id} className="custom-lines-row">

              <select className={elementClass + (this.props.modificationsInvalid ? " input-required-error" : "")}
                value={line.ModificationType}
                onChange={e => this.updateModificationType(line.id, e.target.value)}
              >
                <option value="">Select Type</option>
                <option value="SDR">SDR</option>
                <option value="Custom Modifications">Custom Modifications</option>
              </select>

              <MultiSelectDropDown
                className={this.props.modificationsInvalid ? " input-required-error" : ""}
                options={unitOptions}
                onChange={(id:number, selected:string[]) => this.handleUnitSelectionChange(id, selected)}
                initialSelected={line.ModifiedUnits}
                modificationId={line.id}
                includeAll={submittalUnitChoiceIncludesAll}
                titleText={"Select Units"}
              />   
              {/* Description */}
              {line.ModificationType === "Custom Modifications" ? (
              <div className="description-container">
                <div id={`toolbar-${line.id}`} className="quill-toolbar">
                  {/* Headings */}
                  <select className="ql-header" title="Heading Level" defaultValue="">
                    <option value="1">Heading 1</option>
                    <option value="2">Heading 2</option>
                    <option value="">Normal</option>
                  </select>

                  {/* Basic Formatting */}
                  <button className="ql-bold" title="Bold"></button>
                  <button className="ql-italic" title="Italic"></button>
                  <button className="ql-underline" title="Underline"></button>

                  {/* Lists */}
                  <button className="ql-list" value="ordered" title="Numbered List"></button>
                  <button className="ql-list" value="bullet" title="Bullet List"></button>

                  {/* Indentation */}
                  <button className="ql-indent" value="-1" title="Decrease Indent"></button>
                  <button className="ql-indent" value="+1" title="Increase Indent"></button>

                  {/* Alignment */}
                  <select className="ql-align" title="Text Alignment"></select>

                  {/* Clear Formatting */}
                  <button className="ql-clean" title="Remove Formatting"></button>
                </div>
                <ReactQuill
                  ref={(el) => (this.quillRefs[line.id] = el)}
                  theme="snow"
                  value={line.Description || ""}
                  onChange={(value, delta, source, editor) => {
                    let plainText = editor.getText() || "";
                  
                    // Remove Quill's trailing newline
                    plainText = plainText.replace(/\n$/, "");
                  
                    if (plainText.length > 4000 && source === "user") {
                      const quill = this.quillRefs[line.id]?.getEditor();
                  
                      if (quill) {
                        // Delete only the extra characters beyond 4000
                        quill.deleteText(4000, plainText.length);
                      }
                  
                      return;
                    }
                  
                    // Save sanitized HTML
                    this.sanitizeAndSaveRichText(line.id, "Description", value);
                  }}
                  modules={modules}
                  formats={this.quillFormats}
                />

                <div className={Math.max(0, 4000 - this.getPlainTextLength(line.Description)) !== 0 ? "character-counter" : "character-counter-limit"}>
                  Characters remaining: {Math.max(0, 4000 - this.getPlainTextLength(line.Description))}
                </div>
              </div>
              ) : null}
              {/* SDR Dropdown */}
              {line.ModificationType === "SDR" ? (
              <div className="sdr-description-container">
                <select className={elementClass}
                    value={line.Description}
                    onChange={e => this.updateField(line.id, "Description", e.target.value)}
                >
                    <option value="">Select SDR Option</option>
                    <option value="UV Lights">UV Lights</option>
                    <option value="Refrigeration Only Controls">Refrigeration Only Controls</option>
                    <option value="Motor Removal Rails">Motor Removal Rails</option>
                    <option value="AFMS Electronics Package">AFMS Electronics Package</option>
                    <option value="Full Length Vestibule">Full Length Vestibule</option>
                    <option value="ASHP w/ Supplemental Heat">ASHP w/ Supplemental Heat</option>
                    <option value="ASHP w/ Back-up Heat">ASHP w/ Back-up Heat</option>
                </select>
              </div>
              ) : null}

             {/* SDR Dropdown */}
             {line.ModificationType !== "SDR" && line.ModificationType !== "Custom Modifications" ? (
              <div className="blank-description-container">
                &nbsp;
              </div>
              ) : null}

              {/* Delete Button */}
              <button
                className="delete-button"
                onClick={() => this.removeModification(line.id)}
              >
                ×
              </button>

            </div>
          );
        })}

        {/* Add Button */}
        <button 
          className={"add-line-button " + elementClass + (this.props.modificationsInvalid ? " input-required-error" : "")}
          onClick={() => this.addModification()}
        >
          + Add New Modification
        </button>
      </div>
    );
  }
  private handleUnitSelectionChange (id:number, selected:string[])  {
    const newLines = this.getModifications().map((line:any) =>
      line.id === id ? { ...line, "ModifiedUnits": selected } : line
    );
    this.props.updateRedux("UPDATE_MODIFICATIONS", {modifications: newLines});
  }
  private getUnitOptions(useSubmittalSelectedUnits:boolean) {
    const submittalUnits = this.props.reduxFactoryRequest.factoryRequest?.SelectedUnits ? this.props.reduxFactoryRequest.factoryRequest?.SelectedUnits : [];
    
    //If All is selected in the submittalUnits, then allow all units to show for submittal modifications.
    if (submittalUnits.includes("All")){
      useSubmittalSelectedUnits = false;
    }
    const unitOptions: IOption[] = this.props.reduxFactoryRequestUnits
      .filter((u: any) =>
        u.isActive &&
        (!useSubmittalSelectedUnits || submittalUnits.includes(u.id))
      )
      .map((u: any) => ({
        name: u.unitTag,
        value: u.id
      }));
  
    return unitOptions;
  }
}
//------------------ Redux ----------------------------
function mapStateToProps(state: any) {
    return {
      reduxFactoryModifications: state.reduxFactoryModifications,
      reduxFactoryRequestUnits: state.reduxFactoryRequestUnits,
      reduxFactoryRequest: state.reduxFactoryRequest
    };
  }
  export default connect(mapStateToProps, mapDispatchToProps)(Modifications);
